module.exports = __webpack_public_path__ + "bc89eea16dcf2698d0359026869778e4.png";